export enum ExtendOption {
  ONE_YEAR,
  CHEAPEST,
  LONGEST,
}

export interface ExtendOfferOption {
  shortTitle: string;
  title: string;
  subtitle: string;
  value: ExtendOption;
  selected: boolean;
  agreementLength: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/extendOffer.ts